<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { storageUnit, FileUtils } from '@/common/utils'
import { SupplementaryContractDialog } from '@/components/widgets'
import PhotographicWorksDetail from '../photographic-works-detail/view.vue'
import moment from 'moment'

export default {
    components: { WSupplementaryContractDialog: SupplementaryContractDialog, PhotographicWorksDetail },
    props: {
        listApi: {
            type: String,
            default: 'photoworkList'
        },
        type: {
            type: Number,
            default: 8
        }
    },
    data() {
        return {
            filterDrawer: false,
            filter: {},
            range: [],
            list: [],

            currentPage: 1,
            pageSize: 50,
            total: 0,
            showSupplementaryContractDialog: false,
            currentPhoto: {},
            currentHoverCard: '',
            // 是否启动多选模式
            isBatch: false,
            // 已勾选列表
            checkeds: {},
            photographicDetailDialog: false,
            currentOperation: {},
            loading: false
        };
    },
    methods: {
        init() {
            this.photoworkList()
        },
        async photoworkList(isExport) {
            try {
                this.loading = true

                let data = await this.api[this.listApi](Object.assign(
                    {
                        page: this.currentPage,
                        limit: this.pageSize,
                        checkTimeStart: this.range[0] ? moment(this.range[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
                        checkTimeEnd: this.range[0] ? moment(this.range[1]).format('YYYY-MM-DD 23:59:59') : undefined,
                        contributionId: this.filter.photoId,
                        isExport: +isExport
                    },
                    this.filter
                ))

                let { total } = data

                this.total = total

                data.data.forEach(item => {
                    if(item.thumbPicUrl) {
                        item.previewPics = [item.thumbPicUrl]
                    }else {
                        item.previewPics = item.previewPic.split(',')
                    }
                    item.fileName = item.midIdName || item.fileName
                    item.url = item.fileUrl || item.url
                })

                // 赋值勾选
                if(Object.keys(this.checkeds).length) {
                    data.data.forEach(item => {
                        const isHave = this.checkeds[item.photoId]

                        item.checked = Boolean(isHave)
                    })
                }
                this.list = data.data
            } catch (error) {
                throw new Error(error)
            } finally {
              this.loading = false
            }
        },
        closeFilterDrawer() {},
        clearFilter() {
            this.filter = { }
        },
        async searchClick() {
            this.currentPage = 1

            await this.photoworkList()
            this.filterDrawer = false
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1
            this.photoworkList()
        },
        currentChange(currentPage) {
            this.currentPage = currentPage
            this.photoworkList()
        },
        supplementaryContractClick(item) {
            this.currentPhoto = item

            this.showSupplementaryContractDialog = true
        },
        viewDetail(item) {
            this.currentOperation = item

            this.photographicDetailDialog = true
        },
        // 单文件下载
        async download(item) {
            const fileUtils = new FileUtils(item.url, item.fileName)
            await fileUtils.readUrl()
            await fileUtils.download()
        },
        // 批量文件下载
        async batchDownloadClick() {
            const list = Object.values(this.checkeds)

            list.forEach(item => {
                item.data = item.url
            })

            let instance = this.$loading({ fullscreen: true, text: `正在压缩: ${0}/${list.length}`  });
            try {
                const data = await FileUtils.zip(list, (idx, total) => {
                    instance.setText(`正在压缩: ${idx}/${total}`)
                })
                const fileUtils = new FileUtils()

                let zipName = '摄影作品'
                if(this.type === 9) {
                    zipName = '普通作品'
                }

                fileUtils.download(data, `${zipName}.zip`)
                this.$message.success('下载成功')
                this.cancelClick()
            } finally {
                instance.close()
            }
        },
        cardCheckClick(item) {
            if(this.isBatch) {
                item.checked = !item.checked

                if(item.checked) {
                    this.$set(this.checkeds, item.photoId || item.contributionId, item)
                }else {
                    this.$delete(this.checkeds, item.photoId || item.contributionId)
                }
            }
        },
        // 取消选择点击
        cancelClick() {
            this.list.forEach(item => this.$set(item, 'checked', false))
            this.isBatch = false
        },
        allCheckClick() {
            this.list.forEach(item => {
                item.checked = false
                this.cardCheckClick(item)
            })
        }
    },
    created() {
        this.init()
    },
    computed: {
        // 统计下载数据
        downloadCount() {
            const list = Object.values(this.checkeds)
            let sizeCount = 0

            list.forEach(item => {
                sizeCount += storageUnit.toKb(item.fileSize)
            })

            return { imgCount: list.length, sizeCount: storageUnit.toString(sizeCount) }
        }
    },
    watch: {
        isBatch(val) {
            if(!val) {
                this.checkeds = {}
            }
        }
    }
};
</script>
